import { serverHttp } from "@/plugins/axios";

export const orgs = function() {
    return serverHttp.get("/api/portal/orgs");
};

export const classifications = function(params: object) {
    return serverHttp.get("/api/portal/occupation-classifications", {
        params: params
    });
};

export const occupations = function(params: object) {
    return serverHttp.get("/api/portal/occupations", {
        params: params
    });
};

export const uploadPolicies = function() {
    return serverHttp.get("/api/storage/upload");
};

export const uploadFile = function(formData: FormData) {
    return serverHttp.post("/api/storage/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
};
